import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 2 20 20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BellOff";
const BellOff = memo(themed(Icon));
export {
  BellOff
};
//# sourceMappingURL=bell-off.js.map
